exports = module.exports = require("../../ngapp/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wysihtml5-editor {\n    background-color: #1F2231 !important;\n    color: white !important;\n    font-size: medium !important;\n\n    font-family: 'WorkSans-Regular', 'Work Sans', sans-serif !important;\n\n    height: 400px;\n    overflow-y: scroll;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/resources/static/article-editor-defaults.css
// module id = ../../../../../../resources/static/article-editor-defaults.css
// module chunks = main